import api from './config/api';
import axios from './config/axios';

export default {
    /**
     * Get getMailSettings info
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @returns { AxiosPromise }
     */
    getMailSettings(
        {
            jwtToken,
            websiteId,
            userAccountId,
        },
    ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/settings` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
        } );
    },

    /**
     * saveMailSettings
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param pickupPhotoRequired
     * @param deliveryPhotoRequired
     * @param useDynamicMailStorage
     * @param sendReceiveEmailNotification
     * @param sendReminderEmailNotification
     * @returns { AxiosPromise }
     */
    saveMailSettings(
        {
            jwtToken,
            websiteId,
            userAccountId,
            pickupPhotoRequired,
            deliveryPhotoRequired,
            useDynamicMailStorage,
            dynamicDrawers,
            dynamicFolders,
            sendReceiveEmailNotification,
            sendReminderEmailNotification,
        },
    ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/settings` ),
            method: 'post',
            headers: api.authHeaders( jwtToken ),
            data: {
                pickupPhotoRequired,
                deliveryPhotoRequired,
                useDynamicMailStorage,
                dynamicDrawers,
                dynamicFolders,
                sendReceiveEmailNotification,
                sendReminderEmailNotification,
            },
        } );
    },
};
